import { createFileRoute, redirect } from '@tanstack/react-router';

// This route handles redirects for backwards compatibility purposes
export const Route = createFileRoute('/log-in')({
  beforeLoad: () => {
    throw redirect({
      to: '/login',
    });
  },
  component: () => <div />,
});
